<template>
  <div>Dashboard</div>
</template>

<script>
export default {
	name: 'Dashboard',
};
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue